<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @exportFile="exportFile"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import chooseTemplate from '@/views/financial/components/choose-template'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, chooseTemplate },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'financial-rptCostDep',
        searchForm: {},
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .rptCostDepListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportFile(form) {
      this.chooseTemplateOptions.searchForm = form || {}
      this.chooseTemplateOptions.visible = true
    },
  },
}
</script>
